module.exports = __webpack_public_path__ + "static/media/morning-active.25f601f1.png";